import React from 'react';

export default function CommitteeFilter({
  committees,
  value, 
  onChange,
  includeAllOptions = true,
  className = ""
}) {
  return (
    <select 
      className={`filter-select ${className}`} 
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      {includeAllOptions && <option value="all"> All committees</option>}
      {
        committees.map((committee) => (
          <option key={committee.committee_id} value={committee.committee_id}>
            {committee.name}
          </option>

        ))
      }    
    </select>
  )
}
